module.exports = __webpack_public_path__ + "static/img/1.16507a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/1.jpg
// module id = Hcii
// module chunks = 1